import * as APIHelper from "services/api"
import { SettingConstant } from "shared/constants/setting-constant"
import * as StorageHelper from "utils/storage-helper"

function getAllTokenData() {
  const tokenData = StorageHelper.getStorage(SettingConstant.TOKEN_DATA)
  if (tokenData) {
    return JSON.parse(tokenData)
  }
  return null
}

async function checkTokenValid() {
  const tokenData = getAllTokenData()
  if (!tokenData) return false

  const resp = await APIHelper.getRequest(`${SettingConstant.UAM_SERVICE_URL}check-token-valid`)
  return resp && resp.statusCode == "401" ? false : true
}

function parseJwt(token) {
  var base64Url = token.split(".")[1]
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(""),
  )

  return JSON.parse(jsonPayload)
}

function getAccessTokenData(tokenData) {
  if (!tokenData) tokenData = getAllTokenData()
  if (!tokenData) return null

  return parseJwt(tokenData.id_token)
}

export { getAllTokenData, getAccessTokenData, checkTokenValid }
